var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"column-header"},[_c('span',[_vm._v(_vm._s(_vm.column.title))]),(_vm.type === 'select')?_c('column-select-filter',{attrs:{"type":"experience","field":_vm.field,"label":"","values":_vm.values,"parse-value":name => name}}):_c('column-number-filter',{attrs:{"type":"experience","field":_vm.field}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }